import React, { useState } from "react";
import axios from "axios";
import { editProductURL } from "../components/assets/constants/Urls/Url";
import './EditProduct.css';
import { useParams } from "react-router-dom";

const EditProduct = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    specification: "",
    quantity: "",
    price: "",
    category: "",
    brand: "",
    status: "",
    discount: "",
    colors: "",
    images: [] // Now an array for multiple images
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const { id } = useParams();

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "images") {
      setFormData((prevData) => ({
        ...prevData,
        images: files ? Array.from(files) : []
      }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (key === "images") {
          // Append all images
          value.forEach((file) => data.append("images", file));
        } else {
          data.append(key, value);
        }
      });
      const response = await axios.put(
        editProductURL + id,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred.");
    }
  };

  return (
    <div className="edit-product">
      <h2>Edit Product</h2>
      {message && <p className="success">{message}</p>}
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        {Object.keys(formData).map((field) => (
          <div key={field} className="form-group">
            <label htmlFor={field}>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
            {field === "images" ? (
              <input
                type="file"
                id={field}
                name={field}
                multiple
                accept="image/*"
                onChange={handleChange}
              />
            ) : (
              <input
                type="text"
                id={field}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                placeholder={`Enter ${field}`}
              />
            )}
          </div>
        ))}
        <button type="submit">Update Product</button>
      </form>
    </div>
  );
};

export default EditProduct;
